/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { getPhoneBooksRequestAction, getUnpagedContactRequestAction } from '../../../../../../service/actions/contactActions'
import { IRootState } from '../../../../../../service/store'
import { IContact, PhoneBook } from '../../../../../../service/interfaces/contacts'
import CustomValuesHook from '../../../../../../Hooks/customValuesHook'
import { ArrowBackSvg } from '../../../../../../components/IconSvg'

const DSAppPhonebook = ({ selectPhoneBook }: { selectPhoneBook: Function }) => {
    const unpagedContacts = useSelector((state: IRootState) => state.contactReducer.unpagedContacts)
    const phonebooks = useSelector((state: IRootState) => state.contactReducer.phoneBooks)
    const [states, setStates] = CustomValuesHook({})

    const dispatch = useDispatch()
    useEffect(() => {
        // CachedContact();
        dispatch(getUnpagedContactRequestAction({
            pageSize: 1000,
            pageNumber: 1,
            disablePaging: true,
            sortText: "",
            whereConditionText: ""
        }))
        dispatch(getPhoneBooksRequestAction({
            pageSize: 1000,
            pageNumber: 1,
            disablePaging: true,
            sortText: "",
            whereConditionText: ""
        }))
    }, [])
    const handleSelectPhonebookItem = (selectedPhonebook: PhoneBook) => {
        const phonebookContacts = unpagedContacts?.data?.filter((contact: IContact) => contact.phoneBookId === selectedPhonebook.id)
        setStates({ selectedPhonebook, phonebookContacts })
        selectPhoneBook(selectedPhonebook, phonebookContacts)
    }

    const phonebookHasContact = () => {
        const result: PhoneBook[] = phonebooks?.data?.filter((item: PhoneBook) => {
            return unpagedContacts?.data.some((contact: IContact) => contact.phoneBookId === item.id)
        })
        return result
    }


    return (
        <div className='contacts-page ds-app'>
            <div className='sd-app-phonebook'>
                {!states.selectedPhonebook ? <div className='ds-app-phonebook-list'  >
                    {phonebookHasContact().map((phonebook: PhoneBook, idx: number) => {

                        return (<div
                            onTouchEnd={() => handleSelectPhonebookItem(phonebook)}
                            className='ds-phonebook-item'
                            key={idx}>{phonebook.name}</div>)

                    }

                    )}
                </div> :

                    <div className='d-flex justify-content-between align-items-center ps-2'>
                        <label>{states.selectedPhonebook?.name}</label>
                        <span className='back-to-contact-spn' onTouchEndCapture={() => {
                            setStates({ selectedPhonebook: undefined, phonebookContacts: undefined })
                            selectPhoneBook(undefined, undefined)
                        }} >
                            <ArrowBackSvg fill='#fff' width={20} height={20} />
                        </span>
                    </div>
                }

            </div>
        </div>
    )
}

export default DSAppPhonebook